import React from 'react';

import classNames from 'classnames';

const BlockContentBeautiful = ({ hasDecoration, backgroundStyle, decorationImage, contentCol, reverse, children }) => (
  <div className={classNames(
    'block-content-beautiful',
    {
      decoration: hasDecoration,
      'block-content-beautiful-reverse': reverse
    }
  )} style={backgroundStyle}>
    <div className="block-content-beautiful-background">
      <div className={classNames(
        'row',
        {
          'justify-content-end': !reverse,
          'justify-content-start': reverse
        }
      )}>
        <div className={classNames('col-lg-' + (12 - contentCol), 'd-flex', {
          'justify-content-end': reverse,
          'justify-content-start': !reverse
        },
        'block-content-beautiful-background-image',
        'mb-5',
        'mb-lg-0')}>
          <img style={{
            transform: 'translateY(6px)'
          }} src={decorationImage} role="presentation" />
        </div>
      </div>
    </div>

    <div className="block-content-beautiful-foreground">
      <div className="container">
        <div className={classNames(
          'row',
          {
            'justify-content-end': reverse,
            'justify-content-start': !reverse
          }
        )}>
          <div className={classNames('col-lg-' + contentCol)}>
            {children}
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default BlockContentBeautiful;



// WEBPACK FOOTER //
// ./src/components/block-content-beautiful.js